import {ModelInterface} from "../../data-structures/collection"

// @ts-ignore
import StatusModel from '../status/status-model'

export default class TaskStatus implements ModelInterface {

    id          : string
    statusId    : string
    taskTypeId  : string
    sortPosition: number

    status?     : StatusModel

    constructor(data:any) {
        this.id          = data['id']
        this.statusId    = data['statusId']
        this.taskTypeId  = data['taskTypeId']
        this.sortPosition= data['sortPosition']

        this.status      = gd.session.statuses.get(this.statusId)
    }

    get name (): string {
        return this.status?.name
    }

    get description (): string {
        return this.status?.description
    }

    get systemStatus() {
        return this.status?.systemStatus
    }

    toJSON() {
        return {
            id          : this.id,
            statusId    : this.statusId,
            taskTypeId  : this.taskTypeId,
            sortPosition: this.sortPosition,
        }
    }
}
